import { computed } from '@angular/core';
import { InternalAuthService } from '@eforall/common';
import { DashboardFrameConfig, DashboardMenuItem } from '@eforall/dashboard';
import { environment } from '../../environments';


export function getDashboardFrameConfig(auth: InternalAuthService) {
	return computed(() => {


		const menuItems: DashboardMenuItem[] = [
			{
				label: 'Home',
				routerLink: '/',
				icon: 'fa-light fa-earth-americas',
				separator: false,
			},
			{
				label: 'Configuration',
				icon: 'fa-light fa-folder-gear',
				routerLink: '/configuration',
				subMenu: [{
					label: 'Planning',
					routerLink: '/configuration/planning',
					icon: 'fa-light fa-ballot-check',
				},
				{
					label: 'Accelerators',
					routerLink: '/configuration/accelerators',
					icon: 'fa-light fa-gauge-high',
				},
				{
					label: 'Commitments',
					routerLink: '/configuration/commitments',
					icon: 'fa-light fa-sliders',
				},
				{
					label: 'Email Jobs',
					routerLink: '/configuration/email-jobs',
					icon: 'fa-light fa-envelope',
				}
				],
				separator: true,
			},
			// {
			// 	label: 'Vol Recruitment',
			// 	icon: 'fa-light fa-user-tie',
			// 	routerLink: '/volunteer-recruitment',
			// 	subMenu: [
			// 		{
			// 			label: 'Overview',
			// 			routerLink: '/volunteer-recruitment/overview',
			// 			icon: 'fa-light fa-grid',
			// 		},
			// 		{
			// 			label: 'Engagements',
			// 			routerLink: '/volunteer-recruitment/engagements',
			// 			icon: 'fa-light fa-message-arrow-up-right',
			// 		},
			// 		{
			// 			label: 'Prospects',
			// 			routerLink: '/volunteer-recruitment/prospects',
			// 			icon: 'fa-light fa-user-tie',
			// 		},
			// 	],
			// 	separator: false,
			// },
			{
				label: 'Volunteering',
				icon: 'fa-light fa-handshake',
				routerLink: '/volunteering',
				subMenu: [
					{
						label: 'Overview',
						routerLink: '/volunteering/overview',
						icon: 'fa-light fa-grid',
					},
					{
						label: 'Engagements',
						routerLink: '/volunteering/engagements',
						icon: 'fa-light fa-message-arrow-up-right',
					},
					{
						label: 'Prospects',
						routerLink: '/volunteering/prospects',
						icon: 'fa-light fa-user-tie',
					},
					{
						label: 'Mentors',
						routerLink: '/volunteering/mentors',
						icon: 'fa-light fa-user-tie',
					},
					{
						label: 'Specialists',
						routerLink: '/volunteering/specialists',
						icon: 'fa-light fa-person-chalkboard',
					},
					{
						label: 'All Volunteers',
						routerLink: '/volunteering/all-volunteers',
						icon: 'fa-light fa-list',
					},
				],
				separator: false,
			},
			{
				label: 'Program Experience',
				icon: 'fa-light fa-clipboard-list-check',
				routerLink: '/experience',
				subMenu: [
					{
						label: 'Overview',
						routerLink: '/experience/overview',
						icon: 'fa-light fa-grid',
					},
					{
						label: 'Engagements',
						routerLink: '/experience/engagements',
						icon: 'fa-light fa-message-arrow-up-right',
					},
					{
						label: 'Courses',
						routerLink: '/experience/courses',
						icon: 'fa-light fa-books',
					},
					{
						label: 'Scheduling',
						routerLink: '/experience/scheduling',
						icon: 'fa-light fa-calendar-range',
					},
					{
						label: 'AI Advisor',
						routerLink: '/experience/ai-advisor',
						icon: 'fa-light fa-brain-circuit',
					}],
				separator: false,
			},
			{
				label: 'Program Admissions',
				icon: 'fa-light fa-chart-diagram',
				routerLink: '/admissions',
				subMenu: [
					{
						label: 'Overview',
						routerLink: '/admissions/overview',
						icon: 'fa-light fa-grid',
					},
					{
						label: 'Commitments',
						routerLink: '/admissions/commitments',
						icon: 'fa-light fa-chart-pie-simple-circle-dollar',
					},
					{
						label: 'Engagements',
						routerLink: '/admissions/engagements',
						icon: 'fa-light fa-message-arrow-up-right',
					},
					{
						label: 'Prospects',
						routerLink: '/admissions/prospects',
						icon: 'fa-light fa-address-book',
					},
					{
						label: 'Accelerators',
						routerLink: '/admissions/accelerators',
						icon: 'fa-light fa-gauge-high',
					},
					{
						label: 'Manager',
						routerLink: '/admissions/manager',
						icon: 'fa-light fa-gear',
					}
				],
				separator: false,
			},
			{
				label: 'Program Delivery',
				icon: 'fa-light fa-folder-open',
				routerLink: '/delivery',
				subMenu: [
					{
						label: 'Overview',
						routerLink: '/delivery/overview',
						icon: 'fa-light fa-grid',
					},
					{
						label: 'Engagements',
						routerLink: '/delivery/engagements',
						icon: 'fa-light fa-message-arrow-up-right',
					},
					{
						label: 'Events',
						routerLink: '/delivery/events',
						icon: 'fa-light fa-list',
					},
					{
						label: 'Accelerators',
						routerLink: '/delivery/accelerators',
						icon: 'fa-light fa-gauge-high',
					}],
				separator: false,
			},
			{
				label: 'Alumni Services',
				icon: 'fa-light fa-graduation-cap',
				routerLink: '/alumni',
				separator: false,
			},
		];


		const items: DashboardFrameConfig = {
			appName: 'Programs',
			environmentName: environment.name,
			menu: menuItems,
			signOut: auth.signOut,
		}
		return items;
	});
}